var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.commentsSubView,{tag:"component",on:{"resolve":_vm.resolveComment,"change":_vm.handleViewChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }